export default /* html */ `
<div class="ui-card-content">
  <slot></slot>
</div>`
